class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (e) => "Escape" === e.code && this.close());

    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.setHeaderCartIconAccessibility();

    // Automatically open the cart drawer on the cart page
    if (window.location.pathname === "/cart") {
      this.open();
    }
  }

  setHeaderCartIconAccessibility() {
    const e = document.querySelector("#cart-icon-bubble");
    e.setAttribute("role", "button");
    e.setAttribute("aria-haspopup", "dialog");

    e.addEventListener("click", (t) => {
      t.preventDefault();
      this.open(e);
    });

    e.addEventListener("keydown", (t) => {
      if ("SPACE" === t.code.toUpperCase()) {
        t.preventDefault();
        this.open(e);
      }
    });
  }

  open(e) {
    if (e) {
      this.setActiveElement(e);
    }
    const t = this.querySelector('[id^="Details-"] summary');
    if (t && !t.hasAttribute("role")) {
      this.setSummaryAccessibility(t);
    }

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const e = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const t =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(e, t);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(e) {
    e.setAttribute("role", "button");
    e.setAttribute("aria-expanded", "false");
    if (e.nextElementSibling.getAttribute("id")) {
      e.setAttribute("aria-controls", e.nextElementSibling.id);
    }

    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open")
      );
    });

    e.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(e) {
    const innerDrawer = this.querySelector(".drawer__inner");
    if (innerDrawer.classList.contains("is-empty")) {
      innerDrawer.classList.remove("is-empty");
    }

    this.productId = e.id;

    this.getSectionsToRender().forEach((t) => {
      const targetElement = t.selector
        ? document.querySelector(t.selector)
        : document.getElementById(t.id);
      targetElement.innerHTML = this.getSectionInnerHTML(
        e.sections[t.id],
        t.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }

  setActiveElement(e) {
    this.activeElement = e;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

$(document).ready(function () {
  $('.product-option dt:contains("Size")').siblings("div").addClass("square");
});
